import LangEnum from '../../../lang/LangEnum';
import { stringPhotoUploadMimeType } from '../../media/mimeType';
import {
  CatalogCreationBannerFieldConfig,
  CatalogCreationMediaFieldConfig,
  CatalogMediaDimensions,
} from './catalogCreationForm.types';

export const CATALOG_COVER_DIMENSIONS: CatalogMediaDimensions = {
  width: 2000,
  height: 2500,
};

export const CATALOG_DESKTOP_BANNER_DIMENSIONS: CatalogMediaDimensions = {
  width: 2700,
  height: 600,
};

export const CATALOG_MOBILE_BANNER_DIMENSIONS: CatalogMediaDimensions = {
  width: 1600,
  height: 1200,
};

export const CATALOG_CREATION_MEDIA_FIELDS: CatalogCreationMediaFieldConfig[] = [
  {
    field: 'imageUrl',
    label: LangEnum.GLOBAL_COVER,
    dimensions: CATALOG_COVER_DIMENSIONS,
  },
];

export const CATALOG_BANNERS_MAX_ITEMS = 3;

export const CATALOG_CREATION_BANNER_FIELDS: CatalogCreationBannerFieldConfig[] = [
  {
    field: 'ribbonBannerUrls',
    label: LangEnum.GLOBAL_DESKTOP_BANNER,
    dimensions: CATALOG_DESKTOP_BANNER_DIMENSIONS,
  },
  {
    field: 'ribbonBannerMobileUrls',
    label: LangEnum.GLOBAL_MOBILE_BANNER,
    dimensions: CATALOG_MOBILE_BANNER_DIMENSIONS,
  },
];

export const CATALOG_CREATION_MEDIA_ACCEPTED_TYPES = stringPhotoUploadMimeType;

export const CATALOG_CREATION_MEDIA_TILE_SIZE = 96;

export const CATALOG_CREATION_MEDIA_TILE_GAP = 8;

export const CATALOG_MEDIA_GUIDE_URL =
  'https://docs.teceo.co/docs/midias/guia-de-tamanhos-de-fotos-e-videos';
